import { Trash2 } from 'lucide-react';
import moment from 'moment';
import * as React from 'react';
import styled from 'styled-components';
import InputAddress from '../../../../components_v2/input/InputAddress';
import { DayPicker } from '../../../../components_v2/toolbarFilter/time/DatePicker';
import { PrimaryColor, BorderColor, RedSidely } from '../../../../styles/global/css/Utils';
import { Translate, translateToString } from '../../../../styles/global/translate';
import { FlexDiv } from '../../../products/style';
import { BoolSlider } from '../../../settings/subSettings/CalculatedFieldsCreation';
import { ConstraintType, inputAddressResultToString, ModalCalendarDroppedNodeContainer, ModalCalendarH4, ModalCalendarP } from '../ModalCalendar';
import { ConstraintProps } from './constraints';

const HotelNightContainer = styled.div`
	border: 1px solid ${BorderColor};
	padding: 10px;
	border-radius: 5px;
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const key = 'HotelNights';
type Key = typeof key;

export default function HotelNightsConstraint(props: ConstraintProps) {
	const [constraints, setConstraints] = props.constraintsHook;
	const defaultConstraint = props.defaultConstraints[key];

	const settings = constraints.get(key) as ConstraintType[Key]['settings'];
	const daySet = new Set(settings.nights.map(hotelNight => hotelNight.date));
	return <>
		<ModalCalendarH4>{defaultConstraint.label}</ModalCalendarH4>
		<FlexDiv gap='8px' width='100%'>
			<BoolSlider isActive={settings.allNights} onClick={() => setConstraints(c => {
				settings.allNights = !settings.allNights;
				return new Map(c);
			})} />
			<ModalCalendarP><Translate id='all_nights_in_hotels' /></ModalCalendarP>
		</FlexDiv>
		<ModalCalendarDroppedNodeContainer>
			{settings.nights.map((hotelNight, index) => (
				<HotelNightContainer key={hotelNight.date} style={{ width: '100%' }}>
					<FlexDiv gap='8px'>
						<DayPicker
							containerStyle={{ flexGrow: 1 }}
							isDayBlocked={(day) => daySet.has(day.format('YYYY-MM-DD'))}
							noDayButton
							inputStyle={{ width: '100%' }}
							onDateChange={date => setConstraints(c => {
								settings.nights[index].date = date.format('YYYY-MM-DD');
								return new Map(c);
							})}
							date={moment(hotelNight.date)}
							future
							left='-10px'
						/>
						<Trash2 color={RedSidely} onClick={() => setConstraints(c => {
							settings.nights.splice(index, 1);
							return new Map(c);
						})} cursor='pointer' />
					</FlexDiv>
					<InputAddress
						name={hotelNight.date + '_address'}
						type='text'
						onChange={value => setConstraints(c => {
							settings.nights[index].address = value;
							return new Map(c);
						})}
						value={inputAddressResultToString(hotelNight?.address)}
						label={translateToString('address')}
						placeholder={translateToString('address')}
						optionWidth='250px'
						optionTop='55px'
						inputStyle={{ width: '100%', labelUp: true, containerWidth: '100%', containerHeight: 'fit-content' }}
					/>

				</HotelNightContainer>
			))}
			<a style={{ color: PrimaryColor, fontSize: '12px', width: '100%', alignSelf: 'flex-start' }} onClick={() => setConstraints(c => {
				const momentDate = moment();
				let date = momentDate.format('YYYY-MM-DD');
				while (settings.nights.some(night => night.date === date)) {
					momentDate.add(1, 'day');
					date = momentDate.format('YYYY-MM-DD');
				}
				settings.nights.push({ date });
				return new Map(c);
			})}>
				<Translate id='add_hotel_night' />
			</a>
		</ModalCalendarDroppedNodeContainer>
	</>;
}
